export default __webpack_public_path__ + "static/media/Fanhao.07fd2f44.jpg";